export default __webpack_public_path__ + "static/webinar_banner_1920-fadb8d31f5c32b9996421b1a7d4fc6a9.jpg";